import type { LegacyMatch } from "../api/legacyTypes";

export type ResultMap = Record<string, string>;

export function resultHistoryStorageKey(tournamentId: string) {
  return `localpedia:tournament-results:v1:${tournamentId}`;
}

export function readResultHistory(tournamentId: string): ResultMap | null {
  try {
    const parsed = JSON.parse(localStorage.getItem(resultHistoryStorageKey(tournamentId)) || "null") as { results?: ResultMap } | null;
    return parsed?.results && typeof parsed.results === "object" ? parsed.results : null;
  } catch {
    return null;
  }
}

export function resultSnapshot(matches: LegacyMatch[]) {
  return Object.fromEntries(matches.filter((match) => match.status === "completed" && match.resultSignature).map((match) => [match.sourceKey, match.resultSignature]));
}

export function isUnseenResult(previous: ResultMap | null, match: LegacyMatch) {
  return previous !== null && match.status === "completed" && previous[match.sourceKey] !== match.resultSignature;
}

export function writeResultHistory(tournamentId: string, results: ResultMap) {
  try { localStorage.setItem(resultHistoryStorageKey(tournamentId), JSON.stringify({ results })); } catch { /* optional preference storage */ }
  window.dispatchEvent(new CustomEvent("fp:results-changed", { detail: tournamentId }));
}

export function markResultSeen(tournamentId: string, match: LegacyMatch) {
  writeResultHistory(tournamentId, { ...(readResultHistory(tournamentId) ?? {}), [match.sourceKey]: match.resultSignature });
}

export function markResultsSeen(tournamentId: string, matches: LegacyMatch[]) {
  const results = { ...(readResultHistory(tournamentId) ?? {}) };
  for (const match of matches) {
    if (match.status === "completed" && match.resultSignature) results[match.sourceKey] = match.resultSignature;
  }
  writeResultHistory(tournamentId, results);
}
